var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 15,
    r: 14.5,
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6 15.3a1.3 1.3 0 11-2.6 0 1.3 1.3 0 012.6 0zm4.7 0a1.3 1.3 0 11-2.6 0 1.3 1.3 0 012.6 0zm3.4 1.3a1.3 1.3 0 100-2.6 1.3 1.3 0 000 2.6z",
    fill: "#fff"
  }))));
}
export default __webpack_public_path__ + "static/icon-expand.6300e64b.svg";
export { SvgIconExpand as ReactComponent };